import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import useContext from '../../../context';

export default function Deposit() {
  const [context, updateContext] = useContext();

  return (
    <div className="quoteform__input-group">
      <div className="quoteform__heading">Optional— Deposit</div>
      <div className="quoteform__input">
        <TextField
          fullWidth
          label="Initial Escrow Deposit"
          helperText="The deposit you have paid or will pay your broker"
          variant="outlined"
          type="number"
          name="deposit"
          InputLabelProps={{ shrink: true }}
          value={context.deposit}
          onChange={({ target: { value } }) => updateContext((ctx) => {
            ctx.deposit = value;

            return ctx;
          })}
          inputProps={{ min: 0, 'aria-label': 'Initial Escrow Deposit' }}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/Deposit.js